import 'reflect-metadata';
import { fixture } from '@esui/core/view-testing.js';
import { expect } from '@open-wc/testing';
import { Button } from './index.js';

describe('Button', () => {
  it('wraps mwc-button element without shadow dom', async () => {
    const element = await fixture(Button('my button'));
    const mwcButton = element.firstElementChild;
    expect(mwcButton?.tagName).to.eq('MWC-BUTTON');
  });

  describe('label', () => {
    it('sets label attribute of mwc-button', async () => {
      const element = await fixture(Button('my button'));
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.getAttribute('label')).to.eq('my button');
    });

    it('sets label attribute with label option', async () => {
      const element = await fixture(
        Button('default label').label('my label override')
      );
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.getAttribute('label')).to.eq('my label override');
    });
  });

  describe('raised', () => {
    it('sets raised attribute', async () => {
      const element = await fixture(Button('button').raised());
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.hasAttribute('raised')).to.be.true;
    });
  });

  describe('unelevated', () => {
    it('sets unelevated attribute', async () => {
      const element = await fixture(Button('button').unelevated());
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.hasAttribute('unelevated')).to.be.true;
    });
  });

  describe('outlined', () => {
    it('sets outlined attribute', async () => {
      const element = await fixture(Button('button').outlined());
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.hasAttribute('outlined')).to.be.true;
    });
  });

  describe('dense', () => {
    it('sets dense attribute', async () => {
      const element = await fixture(Button('button').dense());
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.hasAttribute('dense')).to.be.true;
    });
  });

  describe('icon', () => {
    it('sets icon attribute', async () => {
      const element = await fixture(Button('button').icon('arrow_back'));
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.getAttribute('icon')).to.eq('arrow_back');
    });
  });

  describe('trailingIcon', () => {
    it('sets trailingIcon attribute', async () => {
      const element = await fixture(
        Button('button').icon('arrow_back').trailingIcon()
      );
      const mwcButton = element.firstElementChild!;
      expect(mwcButton.hasAttribute('trailingIcon')).to.be.true;
    });
  });
});

describe('disabled', () => {
  it('sets disabled attribute', async () => {
    const element = await fixture(Button('button').disabled());
    const mwcButton = element.firstElementChild!;
    expect(mwcButton.hasAttribute('disabled')).to.be.true;
  });
});

describe('style', () => {
  it('add style to element style attribute', async () => {
    const element = await fixture(Button('button').style('color', 'blue'));

    expect(element.getAttribute('style')).to.eq('color:blue;');
  });
});

describe('attr', () => {
  it('adds custom attribute to element', async () => {
    const element = await fixture(
      Button('button').attr('awesome').attr('count', '3')
    );

    expect(element.hasAttribute('awesome')).to.be.true;
    expect(element.getAttribute('count')).to.eq('3');
  });
});
